(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-elio-minimal"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('elio-minimal-hero')){
    customElements.define('elio-minimal-hero',class extends HTMLElement{
      connectedCallback(){
        this.abort=new AbortController();
        const options={signal:this.abort.signal};
        this.slides=Array.from(this.querySelectorAll('[data-slide]'));
        this.dots=Array.from(this.querySelectorAll('[data-dot]'));
        this.index=0;this.timer=null;this.visible=false;this.hover=false;this.focused=false;
        this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
        this.editor=Boolean(window.Shopify&&window.Shopify.designMode);
        this.paused=this.dataset.autoplay!=='true'||this.motion.matches||this.editor;
        if(this.slides.length<2)return;
        this.classList.add('is-ready');
        this.querySelector('[data-prev]')?.addEventListener('click',()=>this.go(this.index-1,true),options);
        this.querySelector('[data-next]')?.addEventListener('click',()=>this.go(this.index+1,true),options);
        this.dots.forEach(dot=>dot.addEventListener('click',()=>this.go(Number(dot.dataset.dot),true),options));
        this.toggle=this.querySelector('[data-toggle]');
        this.toggle?.addEventListener('click',()=>{this.paused=!this.paused;this.updateToggle();this.schedule();},options);
        this.addEventListener('mouseenter',()=>{this.hover=true;this.schedule();},options);
        this.addEventListener('mouseleave',()=>{this.hover=false;this.schedule();},options);
        this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},options);
        this.addEventListener('focusout',event=>{this.focused=this.contains(event.relatedTarget);this.schedule();},options);
        this.addEventListener('keydown',event=>{
          if(event.target.closest('input,textarea,select,[contenteditable]'))return;
          if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
            event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1),true);
          }
        },options);
        const viewport=this.querySelector('.eh__slides');
        if(this.dataset.touch==='true'){
          viewport.addEventListener('pointerdown',event=>{
            if(!event.isPrimary||event.button!==0)return;
            this.start={x:event.clientX,y:event.clientY,id:event.pointerId};
            clearTimeout(this.timer);
          },options);
          viewport.addEventListener('pointerup',event=>{
            if(!this.start||event.pointerId!==this.start.id)return;
            const dx=event.clientX-this.start.x,dy=event.clientY-this.start.y;
            this.start=null;
            if(Math.abs(dx)>Number(this.dataset.threshold)&&Math.abs(dx)>Math.abs(dy)*1.4){
              this.suppressClick=true;this.go(this.index+(dx<0?1:-1),true);
              clearTimeout(this.clickTimer);this.clickTimer=setTimeout(()=>{this.suppressClick=false;},350);
            }else this.schedule();
          },options);
          viewport.addEventListener('pointercancel',()=>{this.start=null;this.schedule();},options);
          this.addEventListener('pointerup',()=>{},options);
          window.addEventListener('pointerup',()=>{if(this.start){this.start=null;this.schedule();}},options);
          viewport.addEventListener('click',event=>{if(this.suppressClick){event.preventDefault();event.stopPropagation();this.suppressClick=false;}},{capture:true,signal:this.abort.signal});
          viewport.addEventListener('dragstart',event=>event.preventDefault(),options);
        }
        document.addEventListener('visibilitychange',()=>this.schedule(),options);
        this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.updateToggle();this.schedule();},options);
        document.addEventListener('shopify:block:select',event=>{
          const found=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail?.blockId);
          if(found>=0)this.go(found,true);
        },options);
        this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:.15});
        this.observer.observe(this);this.updateToggle();
      }
      updateToggle(){if(this.toggle)this.toggle.textContent=this.paused?this.dataset.playLabel:this.dataset.pauseLabel;}
      schedule(){
        clearTimeout(this.timer);
        if(this.paused||!this.visible||this.hover||this.focused||document.hidden||this.editor||this.motion.matches||this.start)return;
        this.timer=setTimeout(()=>this.go(this.index+1,false),Number(this.dataset.interval));
      }
      go(next,manual){
        next=(next+this.slides.length)%this.slides.length;
        if(manual){this.paused=true;this.updateToggle();}
        if(next!==this.index){
          const old=this.slides[this.index],current=this.slides[next];
          old.hidden=true;old.inert=true;old.setAttribute('aria-hidden','true');old.classList.remove('is-entering');
          current.hidden=false;current.inert=false;current.removeAttribute('aria-hidden');current.classList.add('is-entering');
          this.index=next;
          this.dots.forEach((dot,i)=>{if(i===next)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
          if(manual)this.querySelector('[data-status]').textContent=current.querySelector('.eh__title')?.textContent||'';
        }
        this.schedule();
      }
      disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearTimeout(this.timer);clearTimeout(this.clickTimer);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
